__turbopack_export_value__({
  "nestedRow": "Projects-module__iNRuFG__nestedRow",
  "projectImage": "Projects-module__iNRuFG__projectImage",
  "projectItem": "Projects-module__iNRuFG__projectItem",
});
